import { render } from "./myquestionnaire.vue?vue&type=template&id=4c0413ef&scoped=true"
import script from "./myquestionnaire.vue?vue&type=script&lang=js"
export * from "./myquestionnaire.vue?vue&type=script&lang=js"

import "./myquestionnaire.vue?vue&type=style&index=0&id=4c0413ef&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0413ef"]])

export default __exports__